"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactBootstrap = require("react-bootstrap");

var _bs = require("react-icons/bs");

var _iconobot = _interopRequireDefault(require("../Chatbot/images/iconobot.svg"));

var _ChatX = _interopRequireDefault(require("../Chatbot/images/ChatX.svg"));

var _Chatbot = _interopRequireDefault(require("../Chatbot/Chatbot"));

var _useDisplayMessage = _interopRequireDefault(require("../Chatbot/hooks/useDisplayMessage"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _logoYpf = _interopRequireDefault(require("../images/logo-ypf.svg"));

var _logoYclick = _interopRequireDefault(require("../images/logo-yclick.svg"));

var _logoPasYpf = _interopRequireDefault(require("../images/logo-pas-ypf.svg"));

var _Button = _interopRequireDefault(require("../Button/Button"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Brand = _reactBootstrap.Navbar.Brand;
var Item = _reactBootstrap.NavDropdown.Item;

var Header = function Header(_ref) {
  var expand = _ref.expand,
      className = _ref.className,
      homeLink = _ref.homeLink,
      links = _ref.links,
      activeLink = _ref.activeLink,
      user = _ref.user,
      activePasModule = _ref.activePasModule,
      noYpfModule = _ref.noYpfModule,
      showOtherModules = _ref.showOtherModules,
      onLogOut = _ref.onLogOut,
      pasModules = _ref.pasModules,
      showMenu = _ref.showMenu,
      rolUser = _ref.rolUser,
      logoYclickActive = _ref.logoYclickActive,
      showLogoModules = _ref.showLogoModules,
      yClickLinks = _ref.yClickLinks,
      manyUserRoles = _ref.manyUserRoles,
      showButtonHelp = _ref.showButtonHelp,
      logoPasActive = _ref.logoPasActive,
      titleYClickLinks = _ref.titleYClickLinks,
      colorLineMenu = _ref.colorLineMenu,
      showUserProfile = _ref.showUserProfile,
      onViewProfile = _ref.onViewProfile,
      showChatbot = _ref.showChatbot,
      chatbotPostMessage = _ref.chatbotPostMessage,
      chatbotTyC = _ref.chatbotTyC,
      openModalReference = _ref.openModalReference;

  var UserRoles = function UserRoles(_ref2) {
    var rolUser = _ref2.rolUser,
        manyUserRoles = _ref2.manyUserRoles,
        _ref2$onlyText = _ref2.onlyText,
        onlyText = _ref2$onlyText === void 0 ? false : _ref2$onlyText;
    var rolesText = onlyText ? manyUserRoles.join(', ') : null;
    var roles = rolUser ? /*#__PURE__*/_react.default.createElement("p", null, rolUser) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !onlyText ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", null), /*#__PURE__*/_react.default.createElement("div", {
      className: "d-flex justify-content-start align-items-center"
    }, /*#__PURE__*/_react.default.createElement("p", null, manyUserRoles[0]), manyUserRoles.length > 1 ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.OverlayTrigger, {
      placement: "bottom",
      overlay: /*#__PURE__*/_react.default.createElement(_reactBootstrap.Tooltip, null, manyUserRoles.map(function (rol, index) {
        if (index !== 0) {
          return /*#__PURE__*/_react.default.createElement("p", {
            key: index,
            className: "m-0 p-0"
          }, rol);
        }

        return null;
      }))
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "other-roles-count"
    }, "+".concat(manyUserRoles.length - 1))) : null)) : /*#__PURE__*/_react.default.createElement("p", null, rolesText));
    return roles;
  };

  var getInitials = function getInitials(userName) {
    var initials = '??';

    if (userName) {
      var splitted = userName.toUpperCase().split(' ');
      initials = "".concat(splitted[0][0]).concat(splitted[1][0]);
    }

    return initials;
  };

  var getActiveModule = function getActiveModule(data) {
    var activeModule = pasModules === null || pasModules === void 0 ? void 0 : pasModules.find(function (module) {
      return module.name === activePasModule;
    });
    return activeModule[data];
  };

  var getOtherModules = function getOtherModules() {
    var otherModules = pasModules === null || pasModules === void 0 ? void 0 : pasModules.filter(function (module) {
      return module.name !== activePasModule;
    });
    return noYpfModule ? otherModules.filter(function (module) {
      return module.name !== 'pasypf';
    }) : otherModules;
  };

  var openNewTabInfo = function openNewTabInfo() {
    // Esto no debería ir seteado acá hardcode
    // Pero para una solución urgente en prod se manda así.
    window.open('https://ypf.sharefile.com/d-s5a21d57c682844d4b174ad1ff126a775', '_blank');
  };

  var chatbotDisplay = (0, _useDisplayMessage.default)();

  var ChatbotPopover = /*#__PURE__*/_react.default.createElement(_reactBootstrap.Popover, {
    id: "popover-basic",
    className: "chatbot-custom-popover" //style={{ backgroundColor: 'transparent', width: '100px' }}

  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Popover.Body, {
    className: "chatbot-popover-body"
  }, /*#__PURE__*/_react.default.createElement(_Chatbot.default, {
    display: chatbotDisplay,
    initials: user ? getInitials(user === null || user === void 0 ? void 0 : user.name) : null,
    postMessage: chatbotPostMessage,
    linkTyC: chatbotTyC
  })));

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      menuActive = _useState2[0],
      setMenuState = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      chatbotActive = _useState4[0],
      setChatbotActive = _useState4[1]; // chatbotActive;


  var imgLogoYPF = logoYclickActive && _logoYclick.default || logoPasActive && _logoPasYpf.default || _logoYpf.default;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Navbar, {
    collapseOnSelect: true,
    expand: expand,
    bg: "light",
    className: "container-Header header ".concat(className),
    sticky: "top"
  }, showMenu && /*#__PURE__*/_react.default.createElement("div", {
    className: "hamburger flex flexAligner flexCenter ".concat(menuActive ? 'is-active' : ''),
    onClick: function onClick() {
      return setMenuState(!menuActive);
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "hamburger-box"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "hamburger-inner"
  }))), /*#__PURE__*/_react.default.createElement(Brand, {
    href: homeLink
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: imgLogoYPF,
    alt: "logo-ypf"
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Nav, {
    className: "pas-user-nav ".concat(!showOtherModules && 'hide-pas-dropdown')
  }, showChatbot && /*#__PURE__*/_react.default.createElement(_reactBootstrap.OverlayTrigger, {
    trigger: "click",
    placement: "bottom",
    overlay: ChatbotPopover
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: "chatbot-img",
    src: chatbotActive ? _ChatX.default : _iconobot.default,
    alt: "Chatbot",
    onClick: function onClick() {
      setChatbotActive(!chatbotActive);
    }
  })), showLogoModules && pasModules && activePasModule && /*#__PURE__*/_react.default.createElement(_reactBootstrap.NavDropdown, {
    className: "pas-nav active-module",
    style: {
      '--moduleColor': "".concat(getActiveModule('color'))
    },
    title: /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("img", {
      src: getActiveModule('img'),
      alt: getActiveModule('name')
    }))
  }, getOtherModules().map(function (module, index) {
    return /*#__PURE__*/_react.default.createElement(Item, {
      key: index
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: module.img,
      alt: module.name
    }));
  })), user && /*#__PURE__*/_react.default.createElement("div", {
    className: "user-nav d-flex justify-content-between"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "initials"
  }, user.name && getInitials(user.name)), /*#__PURE__*/_react.default.createElement(_reactBootstrap.NavDropdown, {
    title: /*#__PURE__*/_react.default.createElement("div", {
      className: "user-info"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "d-flex flex-column"
    }, /*#__PURE__*/_react.default.createElement("p", null, user.name), rolUser || manyUserRoles ? /*#__PURE__*/_react.default.createElement(UserRoles, {
      rolUser: rolUser,
      manyUserRoles: manyUserRoles
    }) : /*#__PURE__*/_react.default.createElement("p", null, user.type)), /*#__PURE__*/_react.default.createElement(_bs.BsChevronDown, null))
  }, showUserProfile && /*#__PURE__*/_react.default.createElement("div", {
    className: "user-profile"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "user-initial-profile "
  }, user.name && getInitials(user.name)), /*#__PURE__*/_react.default.createElement("p", {
    className: "user-name"
  }, user.name), /*#__PURE__*/_react.default.createElement(Item, {
    onClick: onViewProfile
  }, /*#__PURE__*/_react.default.createElement(_bs.BsPersonFill, {
    style: {
      width: '15px',
      textAlign: 'center',
      alignItems: 'center'
    }
  }), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, null, "Mi perfil")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.NavDropdown.Divider, null)), /*#__PURE__*/_react.default.createElement(Item, {
    onClick: onLogOut
  }, /*#__PURE__*/_react.default.createElement(_bs.BsBoxArrowInRight, null), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, null, "Cerrar Sesi\xF3n")))), showButtonHelp && /*#__PURE__*/_react.default.createElement(_reactBootstrap.NavDropdown, {
    title: /*#__PURE__*/_react.default.createElement(_Button.default, {
      type: "button",
      colorIcon: "primary",
      variant: "light",
      icon: _bs.BsQuestionCircle,
      widthButton: "65px",
      className: "button-icon-help",
      sizeIcon: "40px"
    }),
    className: "button-help"
  }, /*#__PURE__*/_react.default.createElement(Item, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, null, /*#__PURE__*/_react.default.createElement("p", null, "L\xEDnea de Ayuda YClick:"), /*#__PURE__*/_react.default.createElement("p", null, "Internos: ", /*#__PURE__*/_react.default.createElement("br", null), " 85500 opcion 7"), /*#__PURE__*/_react.default.createElement("p", null, "Externos: ", /*#__PURE__*/_react.default.createElement("br", null), " 0810-1229681 opci\xF3n 4"))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.NavDropdown.Divider, null), /*#__PURE__*/_react.default.createElement(Item, {
    onClick: openNewTabInfo
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, null, "Material de capacitaci\xF3n")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.NavDropdown.Divider, null), /*#__PURE__*/_react.default.createElement(Item, {
    onClick: function onClick() {
      return openModalReference();
    }
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, null, "Referencia de estados")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.NavDropdown.Divider, null)))), /*#__PURE__*/_react.default.createElement("div", {
    className: "mainMenuSideNav ".concat(menuActive ? 'show-menu' : '')
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "yClickLinks yClickLinks-".concat(colorLineMenu, "-line")
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "menu-content"
  }, pasModules && /*#__PURE__*/_react.default.createElement("div", {
    className: "flex flexAligner menu-header"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: getActiveModule('img'),
    alt: getActiveModule('name')
  }), /*#__PURE__*/_react.default.createElement("h4", null, getActiveModule('title'))), links && /*#__PURE__*/_react.default.createElement("div", {
    className: "menu-links"
  }, links.map(function (link) {
    return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Nav.Link, {
      key: link.id,
      href: link.url,
      onClick: (function () {
        return link.callback(link.id);
      }, function () {
        return setMenuState(!menuActive);
      }),
      active: link.id === activeLink
    }, link.title);
  })), yClickLinks && yClickLinks.length > 0 && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex flexAligner menu-yClickLinks-header"
  }, /*#__PURE__*/_react.default.createElement("h4", {
    style: {
      maxWidth: '13rem'
    }
  }, "".concat(titleYClickLinks || 'Gestión de Servicios'))), /*#__PURE__*/_react.default.createElement("div", {
    className: "menu-yClickLinks"
  }, yClickLinks.map(function (yClickLink, index, array) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
      key: yClickLink.id
    }, /*#__PURE__*/_react.default.createElement("h3", {
      className: "menu-yClickLinks-title"
    }, yClickLink.title), /*#__PURE__*/_react.default.createElement("div", {
      className: "menu-liner"
    }), yClickLink.links.map(function (link, i, arr) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
        key: i
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "d-block menu-yClickLinks-links ".concat(i === arr.length - 1 && index !== array.length - 1 ? 'mb-3' : '')
      }, link.isDownload ? /*#__PURE__*/_react.default.createElement("div", {
        className: "link-to-download",
        onClick: function onClick() {
          return link.actionDownload();
        }
      }, link.name) : /*#__PURE__*/_react.default.createElement(_reactBootstrap.Nav.Link, {
        key: link.id,
        href: link.url,
        target: link.target,
        onClick: (function () {
          return link.callback(link.id);
        }, function () {
          return setMenuState(!menuActive);
        }),
        active: link.id === activeLink
      }, link.name)), i === arr.length - 1 ? null : /*#__PURE__*/_react.default.createElement("div", {
        className: "menu-liner"
      }));
    }));
  }))))), /*#__PURE__*/_react.default.createElement("div", {
    className: "dimmer-nav ".concat(menuActive ? 'show-menu' : '', " ").concat(chatbotActive ? 'show-menu' : '')
  }));
};

Header.propTypes = {
  expand: _propTypes.default.string,
  className: _propTypes.default.string,
  homeLink: _propTypes.default.string,
  links: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.number,
    url: _propTypes.default.string,
    callback: _propTypes.default.func,
    title: _propTypes.default.string
  })),
  user: _propTypes.default.shape({
    id: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
    name: _propTypes.default.string,
    type: _propTypes.default.string
  }),
  activeLink: _propTypes.default.number,
  activePasModule: _propTypes.default.oneOf(['pasypf', 'adm', 'pass', 'pasm', 'tsl', '']),
  noYpfModule: _propTypes.default.bool,
  showOtherModules: _propTypes.default.bool,
  onLogOut: _propTypes.default.func,
  pasModules: _propTypes.default.array,
  showMenu: _propTypes.default.bool,
  rolUser: _propTypes.default.string,
  logoYclickActive: _propTypes.default.bool,
  logoPasActive: _propTypes.default.bool,
  showLogoModules: _propTypes.default.bool,
  yClickLinks: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.number,
    title: _propTypes.default.string,
    links: _propTypes.default.arrayOf(_propTypes.default.shape({
      id: _propTypes.default.number,
      url: _propTypes.default.string,
      callback: _propTypes.default.func,
      name: _propTypes.default.string,
      permissions: _propTypes.default.arrayOf(_propTypes.default.string)
    }))
  })),
  manyUserRoles: _propTypes.default.arrayOf(_propTypes.default.string),
  showButtonHelp: _propTypes.default.bool,
  titleYClickLinks: _propTypes.default.string,
  colorLineMenu: _propTypes.default.oneOf(['violet', 'yellow', 'none']),
  showUserProfile: _propTypes.default.bool,
  showChatbot: _propTypes.default.bool,
  chatbotPostMessage: _propTypes.default.func,
  chatbotTyC: _propTypes.default.string,
  onViewProfile: _propTypes.default.func,
  openModalReference: _propTypes.default.func
};
Header.defaultProps = {
  expand: '',
  className: '',
  homeLink: '',
  links: [],
  user: {},
  activeLink: 0,
  activePasModule: '',
  noYpfModule: true,
  showOtherModules: true,
  onLogOut: function onLogOut() {},
  pasModules: null,
  showMenu: true,
  rolUser: '',
  logoYclickActive: false,
  showLogoModules: true,
  yClickLinks: [],
  manyUserRoles: null,
  showButtonHelp: false,
  logoPasActive: false,
  titleYClickLinks: '',
  colorLineMenu: 'none',
  showUserProfile: false,
  showChatbot: false,
  chatbotPostMessage: function chatbotPostMessage() {},
  chatbotTyC: '',
  onViewProfile: function onViewProfile() {},
  openModalReference: function openModalReference() {}
};
var _default = Header;
exports.default = _default;